export default __webpack_public_path__ + "static/media/crdc.e5938dbc.png";